import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Stack } from '@emburse/embark-core';
import { $t } from '../../../../hooks/useTranslation';
export default function CorpAuditConfigExceptionsDrawerFooter({ onBackClick }) {
    return (_jsx(Stack, { justifyContent: "space-between", direction: "row", sx: { paddingTop: '1px' }, children: _jsx(Button, { onClick: onBackClick, variant: "outlined", "data-qa": "back-button", children: $t('Back') }) }));
}
